import { store, getElement, getContext } from '@wordpress/interactivity';

const { state } = store('mediapress-listicle', {
  callbacks: {
    observe: () => {
      if (!state.observer) return;

      const element = getElement().ref;

      state.observer.observe(element);
    },
    scrollToItem: () => {
      const element = getElement().ref;

      if (`#${element.id}` !== window.location.hash) {
        return;
      }

      const context = getContext();
      state.page = Math.max(context.pageNumber, state.page);

      // Wrap this in a timeout to push it off the main thread
      // which allows for the listicles to become visible before
      // executing the scroll.
      setTimeout(() => {
        element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    },
  },
});
